export default __webpack_public_path__ + "static/media/logo-white-4x.ca146d03.png";